import { WpCommitmentDetail } from '../../core/model/wp-commitment-detail.model';
import { SortOrder } from '../../grid';

export function sortByDirectReport(sortDirection: SortOrder = SortOrder.ASC) {
    return (a: WpCommitmentDetail, b: WpCommitmentDetail) => {
        const retVal = byDirectReport(a, b, sortDirection);
        if (retVal !== null) {
            return retVal;
        }
        return 0;
    };
}

export function sortByStartDate(sortDirection: SortOrder = SortOrder.ASC) {
    return (a: WpCommitmentDetail, b: WpCommitmentDetail) => {
        const retVal = byStartDate(a, b, sortDirection);
        if (retVal !== null) {
            return retVal;
        }
        return 0;
    };
}

export function sortByMetric(sortDirection: SortOrder = SortOrder.ASC) {
    return (a: WpCommitmentDetail, b: WpCommitmentDetail) => {
        const retVal = byMetric(a, b, sortDirection);
        if (retVal !== null) {
            return retVal;
        }
        return 0;
    };
}

const byDirectReport = (
    a: WpCommitmentDetail,
    b: WpCommitmentDetail,
    sortDirection: SortOrder,
): number => {
    const s1 = a.username;
    const s2 = b.username;

    let retVal: number | null = null;

    if (s1 === undefined) return -1;
    if (s2 === undefined) return -1;

    if (s1 === null && s2 != null) {
        return -1;
    } else if (s2 === null && s1 != null) {
        return 1;
    } else if (s1 < s2) {
        retVal = 1;
    } else if (s1 > s2) {
        retVal = -1;
    }

    return retVal == null
        ? null
        : sortDirection === SortOrder.ASC
        ? retVal * -1
        : retVal;
};

const byStartDate = (
    a: WpCommitmentDetail,
    b: WpCommitmentDetail,
    sortDirection: SortOrder,
): number => {
    const s1 = a.startDate;
    const s2 = b.startDate;

    let retVal: number | null = null;

    if (s1 === undefined) return -1;
    if (s2 === undefined) return -1;

    if (s1 === null && s2 != null) {
        return -1;
    } else if (s2 === null && s1 != null) {
        return 1;
    } else if (s1 < s2) {
        retVal = 1;
    } else if (s1 > s2) {
        retVal = -1;
    }

    return retVal == null
        ? null
        : sortDirection === SortOrder.ASC
        ? retVal * -1
        : retVal;
};

const byMetric = (
    a: WpCommitmentDetail,
    b: WpCommitmentDetail,
    sortDirection: SortOrder,
): number => {
    const s1 = a.metricName;
    const s2 = b.metricName;

    let retVal: number | null = null;

    if (s1 === undefined) return -1;
    if (s2 === undefined) return -1;

    if (s1 === null && s2 != null) {
        return -1;
    } else if (s2 === null && s1 != null) {
        return 1;
    } else if (s1 < s2) {
        retVal = 1;
    } else if (s1 > s2) {
        retVal = -1;
    }

    return retVal == null
        ? null
        : sortDirection === SortOrder.ASC
        ? retVal * -1
        : retVal;
};
